import React from 'react';
import {Route, Switch} from 'react-router-dom';

import NetworksList from 'routes/app/components/Management/NetworkList';

class Twitter extends React.Component {

  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.path}`} render={() => <NetworksList type="twitter"/>}/>
      </Switch>
    )
  }
}

module.exports = Twitter;



// WEBPACK FOOTER //
// ./routes/app/routes/management/twitter/index.js